import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";

interface IContext {
    isLoading: boolean
    recordCount: number
    search: ISearch
    serialNumbers: ISerialNumber[]

    doSearch: () => void
    updateSearch: (search: ISearch) => void
    changePage: (page: number) => void
    deleteSerialNumber: (id: string) => Promise<void>
}

interface ISerialNumber {
    id: string
    serialNumber: string
    usedBy: string
    isUsed: boolean
}

interface ISearch {
    serialNumber: string
    customerEmail: string
    onlyUsedSerialNumbers: string
    pageNr: number
    pageSize: number
}

export let serialNumbersContext = React.createContext({} as IContext);

let { Provider } = serialNumbersContext;

let SerialNumbersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let location = useLocation();
    let history = useHistory();
    let { enqueueSnackbar } = useSnackbar();

    let [isLoading, setLoading] = useState(true);
    let [recordCount, setRecordCount] = useState(0);
    let [serialNumbers, setSerialNumbers] = useState<ISerialNumber[]>([]);

    let [search, setSearch] = useState<ISearch>({
        serialNumber: '',
        customerEmail: '',
        onlyUsedSerialNumbers: '',
        pageNr: 0,
        pageSize: 20
    })


    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])


    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            setSearch({
                ...search,
                ...state.search
            })
        }

        searchSerialNumbers({
            ...search,
            ...state.search
        });
    }

    let doSearch = () => {
        let request = {
            ...search,
            pageNr: 0
        }

        history.push(location.pathname, { search: request });
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let changePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }

    let searchSerialNumbers = async (search: ISearch) => {
        try {
            setLoading(true);
            let res = await axios.post('/api/SerialNumbers/SearchSerialNumbers', search);
            setSerialNumbers(res.data.items);
            setRecordCount(res.data.recordCount);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let deleteSerialNumber = async (id: string) => {
        if (window.confirm("Are you sure that you want to delete this Serial number?") === false)
            return;

        try {
            let res = await axios.delete(`/api/SerialNumbers/DeleteSerialNumber/${id}`);
            if (res.data.hasDeleted === true) {
                setSerialNumbers(serialNumbers.filter(x => x.id !== id));
                setRecordCount(recordCount - 1);
                enqueueSnackbar("Serial number deleted", { variant: 'success' })
            }
        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    return (
        <Provider
            value={{
                isLoading,
                recordCount,
                search,
                serialNumbers,

                doSearch,
                updateSearch,
                changePage,
                deleteSerialNumber
            }}
        >
            {children}
        </Provider>
    )
}

export default SerialNumbersProvider;